
<div class="best-rental">

    <h2>{{ 'FindYourBestRentalDealfromTrustedPartners' | translate }}</h2>
    <div class="best-rental-brands text-center">
       <ul>
           <li *ngFor="let partner of Partners"> 
               <img matTooltip={{partner.ImageTooltip}} src={{partner.ImagePath}} />
            </li>
       </ul>
    </div>

</div>

